<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true" [fillHeight]="true">
    <div class="ai-analyst-page">
      <div class="page-header">
        <button type="button" class="menu-btn" (click)="toggleRail()">
          <mat-icon>menu</mat-icon>
        </button>
        <span class="page-title">
          <mat-icon>auto_awesome</mat-icon>
          {{ 'AI Data Analyst' | translate }}
        </span>
        <div class="chat-title">
          <mat-icon>chat_bubble_outline</mat-icon>
          @if (!isEditingTitle) {
            <span [class.editable]="activeChat" (click)="startEditingTitle()">{{ activeChat?.title || ('New chat' | translate) }}</span>
          } @else {
            <input type="text" class="title-input" [(ngModel)]="titleInput" [maxlength]="renameMaxLength"
              (blur)="commitTitleEdit()" (keyup.enter)="commitTitleEdit()" (keyup.escape)="cancelEditingTitle()" autofocus>
          }
        </div>
          <app-credit-chip></app-credit-chip>
          <button type="button" class="header-menu-btn" [matMenuTriggerFor]="headerMenu"
            [matTooltip]="'More actions' | translate">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #headerMenu="matMenu" class="header-actions-menu" xPosition="before">
            <button mat-menu-item [disabled]="!activeChat" (click)="onExportConversation()">
              <mat-icon>download</mat-icon><span>{{ 'Export as Markdown' | translate }}</span>
            </button>
            @if (creditsAndSettingsRoute) {
              <button mat-menu-item (click)="onOpenCreditsAndSettings()">
                <mat-icon>settings</mat-icon><span>{{ 'Credits and settings' | translate }}</span>
              </button>
            }
          </mat-menu>
        </div>
        <div class="ai-analyst-body">
          <app-chat-history-rail [chats]="chats" [activeChatId]="activeChat?.id ?? null" [isOpenOnMobile]="railOpen"
            (newChat)="onNewChat()" (chatSelected)="onChatSelected($event)" (starToggled)="onStarToggled($event)"
            (renameCommitted)="onRenameCommitted($event)" (deleteRequested)="onDeleteRequested($event)">
          </app-chat-history-rail>
          @if (railOpen) {
            <div class="scrim" (click)="closeRail()"></div>
          }
          <section class="canvas">
            @if (!activeChat && !isAsking && !isGeneratingReport && askError === null && reportJobStatus === null && !analystDisabled) {
              <app-chat-empty-state (promptSelected)="onSend($event)"></app-chat-empty-state>
            }
            @if (activeChat || isAsking || isGeneratingReport || askError !== null || reportJobStatus !== null || analystDisabled) {
              <app-chat-thread
                [messages]="messages" [isAsking]="isAsking" [askStopping]="askStopping" [askCancelled]="askCancelled" [turnError]="askError" [turnErrorMessage]="askErrorMessage" [turnRetryAfterSeconds]="askRetryAfterSeconds" [progressPhase]="currentProgressPhase"
                [progressSteps]="currentProgressSteps" [turnStepSummaries]="turnStepSummaries"
                [reportJobStatus]="reportJobStatus" [reportJobErrorMessage]="reportJobErrorMessage" [reportCancelRequested]="reportCancelRequested" [reportConnectionLost]="reportConnectionLost"
                (retry)="retryLastAsk()" (optionSelected)="onSend($event)" (cancelReport)="onCancelReportGeneration()" (stopAsking)="onStopAsking()"
              (regenerate)="onRegenerate($event)" (editAndResend)="onEditAndResend($event)"></app-chat-thread>
            }
            <app-chat-composer #composer [disabled]="isAsking || isGeneratingReport || analystDisabled"
            [reportDisabled]="isAsking || isGeneratingReport || analystDisabled" (send)="onSend($event)" (generateReport)="onGenerateReport($event)"></app-chat-composer>
          </section>
        </div>
      </div>
    </app-sidebar-layout>
  </div>
  <app-flyout-container #flyout></app-flyout-container>
